@if (dateRange) {
  <dl class="row">
    <dt class="col-sm-1">{{ label }}:</dt>
    <dd class="col-sm-11">
      @if (dateRange.from && dateRange.to) {
        {{ dateRange.from }} to {{ dateRange.to }}
      }
      @if (dateRange.from && !dateRange.to) {
        Starting {{ dateRange.from }}
      }
      @if (!dateRange.from && dateRange.to) {
        Ending {{ dateRange.to }}
      }
    </dd>
  </dl>
}
